import {createStyles, makeStyles} from '@material-ui/core';

export default createStyles(() => ({
    bold: {
        fontWeight: 'bold !important',
        cursor: 'pointer',
    },
}));

export const useLinkStyles = makeStyles(() =>
    createStyles({
        bold: {
            fontWeight: 'bold',
            cursor: 'pointer',
        },
    })
);
